
























import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ShowMoreText',
  props: {
    description: {
      type: String,
      required: true,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isOpen = ref(Boolean(props.defaultOpen));
    const showMoreText = ref();

    const isOverflowing = ref(false);

    onMounted(() => {
      const resizeObserver = new ResizeObserver(() => {
        isOverflowing.value =
          showMoreText.value?.scrollHeight > showMoreText.value?.clientHeight;
      });
      resizeObserver.observe(showMoreText.value);
    });

    return {
      isOpen,
      showMoreText,
      isOverflowing
    };
  }
});
